module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersWidgetCheckboxes":{"showMore":"další"}},"de":{"CatalogFiltersWidgetCheckboxes":{"showMore":"Nächste"}},"sk":{"CatalogFiltersWidgetCheckboxes":{"showMore":"ďaľšie"}}}')
  delete Component.options._Ctor
}
